import { Box, Button, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

type MarketingCtaBandProps = {
  title: string;
  subtitle?: string;
  to?: string;
  href?: string;
  buttonLabel: string;
  external?: boolean;
};

export const MarketingCtaBand = ({
  title,
  subtitle,
  to,
  href,
  buttonLabel,
  external,
}: MarketingCtaBandProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        mt: 6,
        p: { xs: 3, md: 5 },
        borderRadius: 2,
        textAlign: 'center',
        background: `linear-gradient(135deg, ${theme.palette.mainColors.primary}12 0%, ${theme.palette.mainColors.background1} 100%)`,
        border: `1px solid ${theme.palette.greyShades.border1}`,
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2, maxWidth: 560, mx: 'auto' }}
        >
          {subtitle}
        </Typography>
      )}
      {to && (
        <Button
          component={Link}
          to={to}
          variant="contained"
          size="large"
          sx={{ fontWeight: 700 }}
        >
          {buttonLabel}
        </Button>
      )}
      {href && (
        <Button
          href={href}
          variant="contained"
          size="large"
          sx={{ fontWeight: 700 }}
          {...(external
            ? { target: '_blank', rel: 'noopener noreferrer' }
            : {})}
        >
          {buttonLabel}
        </Button>
      )}
    </Box>
  );
};
